import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskCandidatePulseSurveySubmitted_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskCandidatePulseSurveySubmitted_ActivityLogFragment;
}

const ActivityLogTaskCandidatePulseSurveySubmitted: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.submittedPulseSurveyResponse"
    />
  );
};

ActivityLogTaskCandidatePulseSurveySubmitted.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskCandidatePulseSurveySubmitted_activityLog on ActivityLog {
      id
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskCandidatePulseSurveySubmitted;
